<template>
  <i-button v-bind="$attrs" v-on="listeners" :loading="loading">
    <slot>{{ followLabel }}</slot>
  </i-button>
</template>

<script>
export default {
  props: {
    userId: {
      type: String,
      required: true,
    },
    followed: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    followed(n) {
      this.isFollowed = n
    }
  },
  data() {
    return {
      loading: false,
      isFollowed: this.followed,
    }
  },
  computed: {
    followLabel() {
      return this.isFollowed ? 'Unfollow' : 'Follow'
    },
    listeners() {
      return {
        click: this.toggleFollow,
        ...this.$listeners,
      }
    }
  },
  methods: {
    toggleFollow() {
      if (this.$store.state.user.info && this.$store.state.user.info.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        return false
      } 

      this.loading = true
      let promise;
      if(!this.isFollowed)
        promise = this.$store.dispatch('publicProfile/followUser', { userId: this.userId })
      else
        promise = this.$store.dispatch('publicProfile/unfollowUser', { userId: this.userId })
        promise.then(() => {
          this.isFollowed = !this.isFollowed
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
